import { render, staticRenderFns } from "./LessonPreviewElement.vue?vue&type=template&id=0021e9fa&"
import script from "./LessonPreviewElement.vue?vue&type=script&lang=js&"
export * from "./LessonPreviewElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports